export default "<p>service-review works!</p>\r\n"